import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { getConfidenceBadgeVariant } from '../../utils/productEnrichment';

/**
 * Confidence badge for enrichment list and detail.
 *
 * @param {{ confidence: string }} props
 */
const ProductEnrichmentConfidenceBadge = ({ confidence }) => {
  const variant = getConfidenceBadgeVariant(confidence);
  const label = confidence
    ? String(confidence).charAt(0).toUpperCase() + String(confidence).slice(1)
    : 'Unknown';

  return <Badge bg={variant}>{label}</Badge>;
};

export default ProductEnrichmentConfidenceBadge;
